










































import { Vue, Component, Prop } from 'vue-property-decorator';
import Card from './Card.vue';
import btn from './btn.vue';

@Component({
    components: {
        Card,
        btn
    }
})
export default class PackageCard extends Vue {
    @Prop({default: 'Hajj Ummrah 2019'}) title: string;
    @Prop({default: 'KDS25'}) packageCode: string;
    @Prop({default: '08.21.2019'}) travelDate: string;
    @Prop({default: '11,999'}) startingPrice: string;
    @Prop({default: false}) horizontal: boolean;
    @Prop({default: false}) outline: boolean;
    @Prop() width: number;
    
    @Prop({default: 4}) rating: number;
    /**
     *
     */
    constructor() {
        super();
        // this.packageCode = 'KDS25';
        // this.travelDate = '08.21.2019';
        // this.startingPrice = '$11,999';
    }
}
